import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import {
  viewProposal,
  openReviewContentView
} from '../../store/actions/dealActions';

const styles = theme => ({
  dealContainer: {
    display: 'inline-block',
    width: '100%',
    paddingLeft: '30px',
    paddingTop: '30px',
    paddingBottom: '30px',
    height: '100%'
  },
  circleImage: {
    objectFit: 'cover',
    borderRadius: '50%',
    width: '70px',
    height: '70px'
  },
  displayName: {
    fontWeight: '600'
  },
  rejectFab: {
    background: 'white',
    marginRight: '15px',
    '&:hover': {
      color: '#ce1212'
    }
  },
  shortlistFab: {
    background: 'white',
    marginRight: '15px',
    '&:hover': {
      color: '#22c26e'
    }
  },
  viewProposalButton: {
    color: 'white'
  },
  messageButton: {
    color: 'white',
    boxShadow:
      '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)',
    marginRight: '15px',
    background: 'white',
    color: '#22c26e'
  },
  payoutText: {
    fontWeight: '600'
  },
  contentTitleText: {
    fontWeight: '600'
  },
  bottomRow: {
    paddingLeft: '8px',
    marginLeft: '4px'
  },
  proposedContentContainer: {
    maxHeight: '54px',
    overflowY: 'hidden'
  },
  shortlistedFab: {
    border: '2px solid #22c26e'
  },
  proposalSentText: {
    color: '#22c26e',
    display: 'inline-block',
    width: '140px',
    textAlign: 'center'
  }
});

const mapStateToProps = (state, ownProps) => {
  return {
    profile: state.firebase.profile,
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleReviewContentClick: deal => dispatch(openReviewContentView(deal))
  };
};

export default compose(
  withRouter,
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ profile, auth }) => ({
    profile,
    auth
  })),
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/company/influencerDeal.enhancer.js